
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TarjetaAgregar from './TarjetaAgregar';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useParams } from 'react-router-dom';


export default function Inicio(props) {
  const navigate = useNavigate();
  let { continua } = useParams();
  const [agregarMas, setAgregarMas] = useState(false);

  const handleDespues = () => {
    navigate('/cotizacion');
  }

  const handleContinuar = (value) => {
    setAgregarMas(true);
  }

  const handleRegresar = (value) => {
    if(agregarMas){
      //regresa entre pantallas de este mismo componente/flujo
      //sessionStorage.clear();preguntar si se limpia el storage
      setAgregarMas(!agregarMas);
    } else {
      props.handleRegresar();
    }
  }

  useEffect(() => {
    if(continua){
      setAgregarMas(true);
    }
    /* Especifica cómo sanear este efecto:
    return function cleanup() {
    };*/
  },[continua]);

  return (
    <>
      <IconButton className="back-button" onClick={handleRegresar}>
        <ArrowBackIcon/>
      </IconButton>
      { agregarMas ?
        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2} className="normalize-modal pX-60px">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="minus-pl-32px w-100">
            <p className="hola-txt"></p>
            <p className="desc-txt">¿A qui&eacute;n te gustar&iacute;a asegurar? Dinos qui&eacute;n es el afortunad&#64;</p>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="minus-pl-32px w-100 pt-24">
            <TarjetaAgregar handleAdvertencias={props.handleAdvertencias}/>
          </Grid>
        </Grid>
      :
        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2} className="normalize-modal pX-60px">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="minus-pl-32px w-100">
            <p className="desc-txt">
              ¿Qu&eacute; te parecer&iacute;a asegurar a alguien m&aacute;s?
              (Pareja, hijos, hermanos o personal dom&eacute;stico que compartan el mismo domicilio)
            </p>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="minus-pl-32px w-100 pt-24">
            <Button variant="outlined" disableElevation
              className="boton-para w-100"
              onClick={() => handleDespues()}>
              Tal vez despu&eacute;s
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="minus-pl-32px w-100 pt-24">
            <Button variant="outlined" disableElevation
              className="boton-para w-100"
              onClick={() => handleContinuar()}>
              S&iacute;, me encanta la idea
            </Button>
          </Grid>
        </Grid>
      }
    </>
  );
}